<template>
    <div ref="ganttContainer"></div>
</template>

<script>
import serviceProjetos from '@/services/serviceProjetos'
import Gantt from 'frappe-gantt'

export default {
    props: {
        sprints: {
            type: Array,
            required: true
        },
        isCoordenador: {
            type: Boolean,
            default: false
        },
        isAuditor: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            ganttContainer: null,
            ganttInstance: null
        }
    },
    mounted() {
        this.ganttContainer = this.$refs.ganttContainer
        this.renderizarGantt()
    },
    methods: {
        getDadosGantt() {
            if (!this.sprints) return []

            const tarefas = []

            this.sprints.forEach(sprint => {
                sprint.backlogs.forEach(tarefa => {
                    if (tarefa.status === 'Cancelada') return

                    let cor = '#fdfd25'
                    if (tarefa.status === 'Concluído') cor = '#1d862f'
                    else if (tarefa.status?.startsWith('Em andamento')) cor = '#3359ff'

                    const task = {
                        id: `${tarefa.id}`,
                        name: `${tarefa.descricao}`,
                        codigo: tarefa.codigo,
                        responsavel: tarefa.responsavel ?? '',
                        start: tarefa.dtInicio,
                        end: this.corrigirDataParaGantt(tarefa.dtFim),
                        originalEnd: tarefa.dtFim,
                        progress: 0,
                        dependencies: tarefa.parente_id ? [`${tarefa.parente_id}`] : '',
                        color: cor
                    }

                    if (tarefa.dtInicio && tarefa.dtFim) tarefas.push(task)
                })
            })

            const sortById = (a, b) => {
                const numA = parseInt(a.id)
                const numB = parseInt(b.id)
                return numA - numB
            }

            return tarefas.sort(sortById)
        },

        corrigirDataParaGantt(dataString) {
            const date = new Date(dataString)
            date.setDate(date.getDate() + 1)
            return date.toISOString().slice(0, 10)
        },

        formatarData(data) {
            if (!data) return 'Não definido'
            var dataFormatada = data.split('-')
            return dataFormatada[2] + '/' + dataFormatada[1] + '/' + dataFormatada[0]
        },

        getStatusByColor(color) {
            switch (color) {
                case '#1d862f': return 'Concluído'
                case '#3359ff': return 'Em andamento'
                case '#fdfd25': return 'Pendente'
                default: return 'Indefinido'
            }
        },

        atualizarTarefa(task) {
            var dtInicio = this.corrigirDataParaGantt(task._start)
            var dtFim = task._end.toISOString().split('T')[0]

            var payload = {
                dtInicio: dtInicio,
                dtFim: dtFim,
            }

            serviceProjetos.atualizarTarefa(task.id, payload)
        },


        renderizarGantt() {
            this.ganttContainer.innerHTML = ''
            this.ganttInstance = null
            const tarefas = this.getDadosGantt()
            if (!tarefas.length) return

            this.ganttContainer.innerHTML = ''

            this.ganttInstance = new Gantt(this.ganttContainer, tarefas, {
                date_format: 'YYYY-MM-DD',
                language: 'pt-br',
                readonly: !this.isCoordenador && !this.isAuditor,
                readonly_progress: true,
                popup_on: 'hover',
                today_button: false,
                view_mode: 'Day',
                container_height: '600',
                scroll_to: 'start',
                infinite_padding: false,
                lines: 'vertical',

                on_date_change: (task) => {
                    this.atualizarTarefa(task)
                },

                popup: ({ task }) => `
                <div>
                    <strong style="font-size: 16px">${task.codigo}: ${task.name}</strong>
                    <p style="margin-top: 10px">
                        <strong>Responsável:</strong> ${task.responsavel} <br>
                        <strong>Status:</strong> ${this.getStatusByColor(task.color)}       
                    </p>
                </div>
                `
            })
        }
    }
}
</script>
